import { cloneElement, ReactElement } from "react";
import { Tooltip } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import appColors from "../../../app/appColors";
import { HesapSarkiSesKayitNotlarModel } from "../../../models/businessModels/HesapSarkiSesKayitNotlarModel";
import { PDF_CANVAS_READONLY_NOT_MARKER_OFFSET_Y_PX } from "./pdfCanvasConstants";
import { getHataNotDotTooltip, parseNotKoordinat } from "./pdfCanvasNotHelpers";
import type { PdfCanvasColorMeaning, PdfCanvasPageMeta } from "./pdfCanvasTypes";

interface IPdfCanvasReadonlyNotMarkersProps {
    pageMeta: PdfCanvasPageMeta,
    pageNotlar: HesapSarkiSesKayitNotlarModel[],
    legendItems: PdfCanvasColorMeaning[],
    onDinleNot: (not: HesapSarkiSesKayitNotlarModel) => void,
}

const PdfCanvasReadonlyNotMarkers = (props: IPdfCanvasReadonlyNotMarkersProps) => {
    if (props.pageNotlar.length === 0) {
        return null;
    }

    return <div style={{
        position: "absolute",
        left: "10px",
        top: "10px",
        width: "calc(100% - 20px)",
        height: "calc(100% - 20px)",
        pointerEvents: "none",
        zIndex: 3,
    }}>
        {props.pageNotlar.map(not => {
            const point = parseNotKoordinat(not.koordinat);
            if (!point) {
                return null;
            }

            const leftPct = (point.x / props.pageMeta.width) * 100;
            const topPct = (point.y / props.pageMeta.height) * 100;

            return <Tooltip key={not.id} title={getHataNotDotTooltip(not, props.legendItems)} arrow>
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        props.onDinleNot(not);
                    }}
                    style={{
                        position: "absolute",
                        left: `${leftPct}%`,
                        top: `calc(${topPct}% - ${PDF_CANVAS_READONLY_NOT_MARKER_OFFSET_Y_PX}px)`,
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "auto",
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        border: `2px solid ${not.renkKod ?? appColors.GRAY_LIGHT2}`,
                        background: appColors.WHITE,
                        boxShadow: "0 1px 5px rgba(0,0,0,0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        cursor: "pointer",
                    }}>
                    {cloneElement(appIcons.Sarki.oynatMini as ReactElement, { color: "success", sx: { fontSize: 18 } })}
                </button>
            </Tooltip>;
        })}
    </div>;
};

export default PdfCanvasReadonlyNotMarkers;
